/** Removes all non-digit characters from a CPF string. */
export function normalizeCpf(value: string): string {
  return value.replace(/\D/g, '');
}

/** Validates CPF check digits. Returns true if the CPF is mathematically valid. */
export function isValidCpf(value: string): boolean {
  const digits = normalizeCpf(value);

  if (digits.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(digits)) return false;

  const calcCheckDigit = (base: string, weights: number[]): number => {
    const sum = base.split('').reduce((acc, d, i) => acc + Number(d) * (weights[i] ?? 0), 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const first = calcCheckDigit(digits.slice(0, 9), [10, 9, 8, 7, 6, 5, 4, 3, 2]);
  if (first !== Number(digits[9])) return false;

  const second = calcCheckDigit(digits.slice(0, 10), [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);
  return second === Number(digits[10]);
}
